// extracted by mini-css-extract-plugin
export var faqSummary = "faq-module--faqSummary--F5xvk";